import GuidLookupResourcePagingResultModel from '../../generated/types/model/resource/GuidLookupResourcePagingResultModel';

export default class GuidLookupResourcePagingResultViewModel extends GuidLookupResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
